import { Layout, LayoutContent } from '@steinpilz/react-ux/business-app';

import { AppHeader } from '@components/AppHeader';
import { Loader } from '@infrastructure/loader';
import { NotificationSetup } from '@api/client/utils';

import { Pages } from './pages';
import { AppFooter } from '@components/AppFooter';
import { UnsavedChangesDialog } from '@infrastructure/unsaved-changes/components/UnsavedChangesDialog';
import { AntdLocaleProvider } from './AntdLocaleProvider';
import { AppLayoutFix } from './styled';

const Index = () => (
  <Layout>
    <AntdLocaleProvider>
      <AppLayoutFix />
      <Loader />
      <NotificationSetup />
      <UnsavedChangesDialog />

      <AppHeader />
      <LayoutContent type="dark">
        <Pages />
      </LayoutContent>
      <AppFooter />
    </AntdLocaleProvider>
  </Layout>
);

export default Index;
